import React from 'react';
import { Routes, Route, Navigate, useLocation } from 'react-router-dom';
import { useAuth } from './services/AuthContext';

// Pages
import Home from './pages/Home';
import Login from './pages/Login';
import ChartDetailView from './pages/ChartDetailView';
import AdminPanel from './pages/AdminPanel';
import AdminImport from './pages/AdminImport';
import PipelineRunsPage from './pages/PipelineRunsPage';
import IndexesPage from './pages/IndexesPage';
import SectorsPage from './pages/SectorsPage';
import ScreenerPage from './pages/ScreenerPage';
import NotFound from './pages/NotFound';

// Components
import Header from './components/Header';
import Footer from './components/Footer';
import ProtectedRoute from './components/ProtectedRoute';
import AdminRoute from './components/AdminRoute';

// Old shared links of the form /?q=... used to open the Dashboard; the
// Screener replaces it.
function HomeOrScreener() {
  const location = useLocation();
  if (new URLSearchParams(location.search).get('q')) {
    return <Navigate to="/screener" replace />;
  }
  return <Home />;
}

function App() {
  const { isLoading } = useAuth();

  if (isLoading) {
    return (
      <div className="flex items-center justify-center h-screen">
        <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-blue-500"></div>
      </div>
    );
  }

  return (
    <div className="flex flex-col min-h-screen">
      <Header />
      <main className="flex-grow container mx-auto px-4 py-8">
        <Routes>
          <Route path="/" element={<HomeOrScreener />} />
          <Route path="/login" element={<Login />} />
          {/* The Dashboard was retired; keep old bookmarks working. */}
          <Route path="/dashboard" element={<Navigate to="/screener" replace />} />
          <Route
            path="/screener"
            element={
              <ProtectedRoute>
                <ScreenerPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/indexes"
            element={
              <ProtectedRoute>
                <IndexesPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/sectors"
            element={
              <ProtectedRoute>
                <SectorsPage />
              </ProtectedRoute>
            }
          />
          <Route 
            path="/chart/:stockId" 
            element={
              <ProtectedRoute>
                <ChartDetailView />
              </ProtectedRoute>
            } 
          />
          <Route 
            path="/admin" 
            element={
              <AdminRoute>
                <AdminPanel />
              </AdminRoute>
            } 
          />
          <Route
            path="/admin-import"
            element={
              <AdminRoute>
                <AdminImport />
              </AdminRoute>
            }
          />
          <Route
            path="/admin/pipeline-runs"
            element={
              <AdminRoute>
                <PipelineRunsPage />
              </AdminRoute>
            }
          />
          <Route path="/404" element={<NotFound />} />
          <Route path="*" element={<Navigate to="/404" replace />} />
        </Routes>
      </main>
      <Footer />
    </div>
  );
}

export default App;
